module.exports = __webpack_public_path__ + "media/images/area/popular/akihabara-0683207f07a6d9b4be24d8f6b9759e31.jpg";